import React from 'react'

const JointeamSection = () => {
  return (
    <div className='Join-Section'>
      <div className="container" >
        <div className="row" style={{background:'#157438', color:'#fff',padding:'60px',margin:'50px auto',borderRadius:'30px'}}>
            <div className="col-sm-9 col-12">
                <h5>Join the team</h5>
                <h2>Become part of a team that is redefining how the<br/> AEC industry builds and collaborates.</h2>
                <p style={{padding:'0',margin:'0',fontWeight:'200'}}>
                    At Fractile, you'll work on impactful projects, learn from seasoned leaders, and grow your technical craft. If you're committed to excellence, we're committed to you.
                </p>
            </div>            
            {/* <div className="col-sm-1 col-12"/> */}
            <div className="col-sm-3 col-12" style={{display:'flex', alignItems:'end'}}>
                <button className="btn-2-white" style={{width:'90%'}}>
                    Explore Opportunity
                </button>
            </div>
        </div>
      </div>
    </div>
  )
}

export default JointeamSection
